import { ErrorPacket, Next, Pipe } from '../types';
import { ErrorConverterService } from '../../services/error-converter.service';

export class PromiseRejectionPipe implements Pipe<ErrorPacket, ErrorPacket> {
    public constructor(private readonly errorConverter: ErrorConverterService) {}

    public handle(packet: ErrorPacket, next: Next<ErrorPacket, ErrorPacket>): ErrorPacket {
        if (packet.result) return next(packet);

        const error: any = packet.data;

        if (!error?.promise || !error?.rejection?.error?.errors) {
            return next(packet);
        }

        return {
            ...packet,
            result: this.errorConverter.getAppErrorFromJsonApi(error.rejection.error),
        };
    }
}
